import roundPlanningService from '@/services/roundPlanning.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roundPlannings: [],
		filterRoundPlannings: [],
		roundPlanning: {},
		roundPlanningStatistics: [],
		searchParams: {
			name: '',
			customerId: '',
			mapId: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0,
		filterPaginationParams: {
			pageSize: 10,
			currentPage: 1,
			totalCount: 0,
			totalPages: 0
		}
	},

	mutations: {
		SET_ROUNDPLANNINGS(state, roundPlannings) {
			state.roundPlannings = roundPlannings;
		},
		SET_FILTER_ROUNDPLANNINGS(state, roundPlannings) {
			state.filterRoundPlannings = roundPlannings;
		},
		SET_ROUNDPLANNING(state, roundPlanning) {
			state.roundPlanning = roundPlanning;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_FILTER_PAGESIZE(state, pageSize) {
			state.filterPaginationParams.pageSize = pageSize;
		},
		SET_FILTER_CURRENTPAGE(state, currentPage) {
			state.filterPaginationParams.currentPage = currentPage;
		},
		SET_FILTER_TOTALPAGES(state, totalPages) {
			state.filterPaginationParams.totalPages = totalPages;
		},
		SET_FILTER_TOTALCOUNT(state, totalCount) {
			state.filterPaginationParams.totalCount = totalCount;
		},
		SET_MAPID(state, mapId) {
			state.searchParams.mapId = mapId;
		},
		SET_ROUNSTATISTICS(state, roundPlanningStatistics) {
			state.roundPlanningStatistics = roundPlanningStatistics;
		}
	},

	actions: {
		async getRoundPlanning({ commit }, roundPlanningId) {
			return await roundPlanningService
				.getRoundPlanning(roundPlanningId)
				.then(data => {
					commit('SET_ROUNDPLANNING', data);
				})
				.catch(err => {
					console.log('Error getting roundPlanning: ', err);
				});
		},

		async getRoundPlannings({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });

			state.searchParams.customerId = rootGetters['user/getActiveCustomer']?.id;
			state.searchParams.userBuildingId = rootGetters['buildingStore/getUserBuildingId'];

			return await roundPlanningService
				.getRoundPlannings(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_ROUNDPLANNINGS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoundPlannings');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundPlannings: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getFilterRoundPlannings(
			{ commit, dispatch, rootGetters, state },
			params
		) {
			var searchParams = {
				buildingId: params.buildingId,
				orderBy: 'name',
				pageNumber: state.filterPaginationParams.currentPage,
				pageSize: state.filterPaginationParams.pageSize,
				performerRoles: params.roles,
				userBuildingId: rootGetters['buildingStore/getUserBuildingId']
			};
			dispatch('appStore/setLoading', 1, { root: true });

			if (!rootGetters['user/hasFull']) {
				searchParams.customerId = rootGetters['user/getUser'].customer.id;
			} else {
				searchParams.customerId = rootGetters['user/getActiveCustomer']?.id;
			}

			return await roundPlanningService
				.getRoundPlannings(searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.filterPaginationParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_FILTER_ROUNDPLANNINGS', data);
						commit('SET_FILTER_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_FILTER_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_FILTER_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_FILTER_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoundPlannings');
					}

					commit('SET_FILTER_ROUNDPLANNINGS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundPlannings: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getRoundStatistics({ commit, rootGetters }, params) {
			if (!rootGetters['user/hasFull']) {
				params.customerId = rootGetters['user/getUser'].customer.id;
			} else {
				params.customerId = rootGetters['user/getActiveCustomer']?.id;
			}

			try {
				const data = await roundPlanningService.getRoundStatistics(params);
				commit('SET_ROUNSTATISTICS', data);
			} catch (error) {
				console.log(error);
			}
		},

		async createRoundPlanning({ dispatch }, roundPlanning) {
			return await roundPlanningService
				.createRoundPlanning(roundPlanning)
				.then(data => {
					dispatch('getRoundPlannings');

					return data;
				})
				.catch(err => {
					console.log('Error creating roundPlanning: ', err);
				});
		},
		async updateRoundPlanning({ dispatch }, roundPlanning) {
			return await roundPlanningService
				.updateRoundPlanning(roundPlanning)
				.then(() => {
					dispatch('getRoundPlannings');
				})
				.catch(err => {
					console.log('Error updating roundPlanning: ', err);
				});
		},
		async deleteRoundPlanning({ dispatch }, roundPlanning) {
			return await roundPlanningService
				.deleteRoundPlanning(roundPlanning.id)
				.then(() => {
					dispatch('getRoundPlannings');
				})
				.catch(err => {
					console.log('Error deleting roundPlanning: ', err);
				});
		},
		// eslint-disable-next-line no-empty-pattern
		async triggerMail({}, roundId) {
			return await roundPlanningService
				.triggerRoundMail(roundId)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Error sending mail:', err);
				});
		},
		setRoundPlanning({ commit }, roundPlanning) {
			commit('SET_ROUNDPLANNING', roundPlanning);
		},
		setRoundPlannings({ commit }, roundPlannings) {
			commit('SET_ROUNDPLANNINGS', roundPlannings);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roundPlanning: state => {
			return state.roundPlanning;
		},
		roundPlannings: state => {
			return state.roundPlannings;
		},
		filterRoundPlannings: state => {
			return state.filterRoundPlannings;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
